import { documentsQueryKeys } from '@src/documents/queryKeys';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Props = {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
};

export const useGeneratePdf = ({ orderId, onSuccess, onError }: Props) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: async () => {
      await OrdersClient.generatePdf(orderId);
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: documentsQueryKeys.byOrderId(orderId),
      });
      onSuccess();
    },
    onError,
  });

  return {
    generatePdf: mutate,
  };
};
